export default __webpack_public_path__ + "static/media/proj-mahadev.aa9d31db.jpg";